import { hydrateWidgets } from 'DVWebNodeUtils';
import { RetailNav } from '../../widgets/Explore/DVWebNodeNav/RetailNav';
hydrateWidgets(RetailNav);